import { z } from 'zod';

export const machineFormSchema = z.object({
  name: z.string()
    .min(1, 'El nombre es requerido')
    .max(100, 'El nombre debe tener máximo 100 caracteres'),
  model: z.string()
    .max(100, 'El modelo debe tener máximo 100 caracteres')
    .optional()
    .or(z.literal('')),
  type: z.string()
    .max(100, 'El tipo debe tener máximo 100 caracteres')
    .optional()
    .or(z.literal('')),
  description: z.string()
    .max(500, 'La descripción debe tener máximo 500 caracteres')
    .optional()
    .or(z.literal('')),
  maintenance_schedule: z.string()
    .max(200, 'El programa de mantenimiento debe tener máximo 200 caracteres')
    .optional()
    .or(z.literal('')),
  is_active: z.boolean().default(true),
});

export type MachineFormData = z.infer<typeof machineFormSchema>;
